/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var TreeMouseEventTarget;
(function (TreeMouseEventTarget) {
  TreeMouseEventTarget[TreeMouseEventTarget["Unknown"] = 0] = "Unknown";
  TreeMouseEventTarget[TreeMouseEventTarget["Twistie"] = 1] = "Twistie";
  TreeMouseEventTarget[TreeMouseEventTarget["Element"] = 2] = "Element";
})(TreeMouseEventTarget || (TreeMouseEventTarget = {}));
export class TreeError extends Error {
  constructor(user, message) {
    super(`TreeError [${user}] ${message}`);
  }
}
export class WeakMapper {
  constructor(fn) {
    this.fn = fn;
    this._map = new WeakMap();
  }
  map(key) {
    let result = this._map.get(key);
    if (!result) {
      result = this.fn(key);
      this._map.set(key, result);
    }
    return result;
  }
}